import { Portal, Content as RadixContent } from '@radix-ui/react-context-menu';
import type React from 'react';
import { forwardRef } from 'react';
import { popupClassNames } from '../common';

interface ContentProps {
  children: React.ReactNode;
  className?: string;
  'data-testid'?: string;
  onCloseAutoFocus?: (event: Event) => void;
}

/**
 *  Nested Content component for the ContextMenu component. Place below 'Trigger' component.
 * ```tsx
 *  import Content from '~/components2/ContextMenu/Content'
 *
 *  <Content className="text-lg hover:scale-105 ...">
 *    <Item>Some Item</Item>
 *    <SubMenu label="Text to Display">
 *      <Item>Another Item</Item>
 *    </SubMenu>
 *  </Content>
 * ```
 *  @param {children} props.children - ContextMenu subitems (Item.tsx, SubMenu.tsx) to display when right-clicked.
 *  @param {className} props.className - (optional) additional classNames to be added to the component styling.
 *  @returns
 */

const Content = forwardRef(({ children, className, ...rest }: ContentProps, ref) => {
  return (
    <Portal>
      <RadixContent className={`${popupClassNames} ${className}`} {...rest}>
        {children}
      </RadixContent>
    </Portal>
  );
});

Content.displayName = 'Content';
export default Content;
